











import Vue from "vue";
import es from "vuetify/src/locale/es";
import { mapState } from "vuex";

export default Vue.extend({
  props: ["status", "props", "data"],
  computed: {
    ...mapState("data", ["estados"]),
    chip() {
      const { estados } = this;
      let estado = this.status;
      if (this.status === "PI") {
        if (this.data?.tipo_aceptacion === "PST") estado = "PRE_PST";
        else if (this.data?.tipo_aceptacion === "PNC") estado = "PRE_PNC";
      } else if (this.status === "A") {
        if (this.data?.tipo_aceptacion === "PST") estado = "A_PST";
        else if (this.data?.tipo_aceptacion === "PNC") estado = "A_PNC";
      }

      return estados[estado] || estados["?"];
    },
  },
});
